import { render, staticRenderFns } from "./BlockedUsers.vue?vue&type=template&id=eebc27c2&scoped=true"
import script from "./BlockedUsers.vue?vue&type=script&setup=true&lang=js"
export * from "./BlockedUsers.vue?vue&type=script&setup=true&lang=js"
import style0 from "./BlockedUsers.vue?vue&type=style&index=0&id=eebc27c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eebc27c2",
  null
  
)

export default component.exports